<template>
  <div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <dl v-if="info !== null" class="row">
      <dt class="col-sm-2">Name</dt>
      <dd class="col-sm-10">{{info.name}}</dd>

      <dt class="col-sm-2">Description</dt>
      <dd
        class="col-sm-10"
        :class="getDescriptionClass"
      >
        {{descriptionStr}}
      </dd>

      <dt class="col-sm-2">Leader</dt>
      <dd class="col-sm-10">
        <player-link :playerId="info.owner_id" />
      </dd>

      <dt class="col-sm-2">Created</dt>
      <dd class="col-sm-10">{{info.ctime | getMomentStr}}</dd>

      <dt class="col-sm-2">Type</dt>
      <dd class="col-sm-10">{{info.type | getClubTypeStr}}</dd>

      <dt class="col-sm-2">Min level</dt>
      <dd class="col-sm-10">{{info.min_level}}</dd>

      <dt class="col-sm-2">Lang</dt>
      <dd class="col-sm-10">{{info.lang | getLangNameEn}}</dd>

      <dt class="col-sm-2">Country</dt>
      <dd class="col-sm-10">{{info.country | getOptionalStringStr}}</dd>
    </dl>

 </div>
</template>

<script>
import { HTTP } from '../http-common';

import { LOAD_STATE_INIT    } from '../util';
import { LOAD_STATE_LOADING } from '../util';
import { LOAD_STATE_LOADED  } from '../util';

import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import PlayerLink from './PlayerLink.vue';

export default {
  name: 'ClubInfo',

  components: {
    LoadingIndicator,
    PlayerLink,
  },

  props: {
    clubId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,
      info: null,
    };
  },

  computed: {
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    isLoaded() {
      return this.loadState === LOAD_STATE_LOADED;
    },

    message() {
      if(this.isLoaded && this.info === null) {
        return 'Club not found.';
      }
      return null;
    },

    descriptionStr() {
      if(this.info === null) {
        return null;
      }

      const trimmedDescription = this.info.description.trim();
      if(trimmedDescription.length === 0) {
        return 'Not specified';
      }
      return trimmedDescription;
    },

    getDescriptionClass() {
      return {
        'not-specified': !this.isDescriptionSpecified,
      };
    },

    isDescriptionSpecified() {
      const trimmedDescription = this.info.description.trim();
      return trimmedDescription.length > 0;
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.loadState = LOAD_STATE_LOADING;
    HTTP.get('/club/' + this.clubId + '/info')
    .then(response => {
      this.info = response.data.data;
    })
    .catch(e => {
      notifier.showError(e.response.data, {sender: this});
    })
    .finally(() => {
      this.loadState = LOAD_STATE_LOADED;
    });
  },

  filters: {
    getClubTypeStr(clubTypeCode) {
      switch(clubTypeCode) {
        case  0: return 'open';
        case  1: return 'private';
        default:
          return `Unknown club type code (${clubTypeCode})`;
      }
    },
  },
};
</script>
